module.exports = __webpack_public_path__ + "market/static/img/scratchcard.5f14531.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award/scratchcard.png
// module id = 46/l
// module chunks = 1